import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Placeholder from '../../common/Placeholder'

const EventSubmitted = ({ isEdit, onClick }) => {
  const { t } = useTranslation()

  return (
    <div className='row'>
      <div className='col-6 mx-auto vh-100 mt-5 animated fadeInUp'>
        <Placeholder
          title={isEdit
            ? t('events.modal.eventSubmitted.titleUpdating')
            : t('events.modal.eventSubmitted.titleCreating')}
          icon={'fa-cloud-upload'}
          subtext1={isEdit
            ? t('events.modal.eventSubmitted.subtextUpdated')
            : t('events.modal.eventSubmitted.subtextCreated')}
          subtext2={t('events.modal.eventSubmitted.refreshHint')}
          buttonText={t('events.modal.eventSubmitted.goToEvents')}
          buttonIcon={'fa-arrow-left'}
          handleClick={() => onClick()}
        />
      </div>
    </div>
  )
}

EventSubmitted.propTypes = {
  isEdit: PropTypes.bool,
  onClick: PropTypes.func,
}

export default EventSubmitted
